import { initialState } from './signingInitialState';
import { Actions } from './signingTypes';
const shouldShowSigningFlow = (approvalStatus) => ['CREATED', 'REJECTED', 'UNKNOWN'].includes(approvalStatus);
const reducer = (state, action) => {
    switch (action.type) {
        case Actions.SIGN_START:
            return {
                ...state,
                signingOperationPending: true,
            };
        case Actions.SIGN_SUCCESS:
            return {
                ...state,
                signingStatus: action.result.status,
                redirectUri: action.result.returnUrl,
                dynamicLinkId: action.result.dynamicLinkId,
                showSigningFlow: shouldShowSigningFlow(action.result.status),
                signingOperationPending: false,
                bankIDOnly: action.result.bankIdOnly,
            };
        case Actions.SIGN_ERROR:
            return {
                ...state,
                signingOperationPending: false,
                dynamicLinkId: undefined,
                signingError: action.error,
                showSigningFlow: false,
            };
        case Actions.CLEAR_ERROR:
            return {
                ...state,
                signingError: undefined,
            };
        case Actions.RESET:
            return {
                ...initialState,
            };
        case Actions.CANCEL_SIGNING:
            return {
                ...state,
                signingStatus: undefined,
                signingOperationPending: false,
                signingError: undefined,
                showSigningFlow: false,
            };
        case Actions.CANCEL:
            return {
                ...state,
                signingStatus: 'CANCELLED',
                signingOperationPending: true, // TODO: should be set to false?
                signingError: undefined,
                showSigningFlow: false,
            };
        case Actions.COMPLETE_SIGNING:
            return {
                ...state,
                signingStatus: action.status,
                signingOperationPending: false,
                showSigningFlow: shouldShowSigningFlow(action.status),
            };
        case Actions.UPDATE_STATUS:
            return {
                ...state,
                signingStatus: action.status,
                signingOperationPending: action.status === 'CREATED',
                showSigningFlow: shouldShowSigningFlow(action.status),
            };
        case Actions.PAYMENT_CHECKED:
            return {
                ...state,
                signingStatus: action.status,
                signingOperationPending: false,
                showSigningFlow: false,
            };
        default:
            return state;
    }
};
const withLogger = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cSigningState', 'color: green; font-weight: bold', state, Array.from(Object.values(Actions))[action.type], 'new state', newState);
    }
    return newState;
};
export default withLogger;
//# sourceMappingURL=data:application/json;base64,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